import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { TextMessage, ActionExecutionMessage, ResultMessage } from "@copilotkit/runtime-client-gql";
import { FRONTEND_TOOL_NAMES } from "@/constants/aira";

/** A normalised CopilotKit message used for internal manipulation before setMessages. */

/** A batched assistant turn with its associated tool-call messages. */

/** Removes empty assistant messages, fallback_handler entries, doNotSave_ prefixes, and known error strings. */
export function filterMessages(messages) {
  return messages.filter(function (message) {
    return !(message.type === "TextMessage" && message.role === "assistant" && message.content === "" || message.type === "ActionExecutionMessage" && message.name === "fallback_handler" || message.type === "ResultMessage" && message.actionName === "fallback_handler" || message.id.startsWith("doNotSave_") || message.content === "The task is failed. Please try again." || message.content === "❌ An error occurred. Please try again." || message.content === "");
  });
}

/** Converts plain CopilotMessage objects into typed CopilotKit runtime instances for setMessages. */
export function formatCopilotMessages(copilotMessages) {
  return copilotMessages.map(function (message) {
    if (message.type === "TextMessage") {
      var _message$content;
      return new TextMessage({
        id: message.id,
        role: message.role,
        content: (_message$content = message.content) !== null && _message$content !== void 0 ? _message$content : "",
        createdAt: message.createdAt
      });
    } else if (message.type === "ActionExecutionMessage") {
      var _message$name, _message$arguments;
      return new ActionExecutionMessage({
        id: message.id,
        name: (_message$name = message.name) !== null && _message$name !== void 0 ? _message$name : "",
        arguments: (_message$arguments = message.arguments) !== null && _message$arguments !== void 0 ? _message$arguments : {},
        createdAt: message.createdAt
      });
    } else if (message.type === "ResultMessage") {
      var _message$actionName;
      return new ResultMessage({
        id: message.id,
        actionExecutionId: message.id.split("result-")[1],
        actionName: (_message$actionName = message.actionName) !== null && _message$actionName !== void 0 ? _message$actionName : "",
        result: typeof message.result === "string" ? message.result : JSON.stringify(message.result),
        createdAt: message.createdAt
      });
    }
    throw new Error("Unknown message type: ".concat(message.type));
  });
}

/** Returns true when every ActionExecutionMessage in the list has a corresponding ResultMessage. */
export function allToolCallsResolved(messages) {
  var actionIds = messages.filter(function (m) {
    return m.type === "ActionExecutionMessage";
  }).map(function (m) {
    return m.id;
  });
  var resolvedIds = new Set(messages.filter(function (m) {
    return m.type === "ResultMessage";
  }).map(function (m) {
    return m.actionExecutionId;
  }));
  return actionIds.every(function (id) {
    return resolvedIds.has(id);
  });
}

/** Builds the flat CopilotMessage list from batched conversations, replacing backend tool calls with fallback_handler stubs. */
export function buildMessagesFromConversations(conversations) {
  var result = [];
  conversations.forEach(function (conversation) {
    var _conversation$toolCal, _conversation$toolCal2, _conversation$toolCal3;
    result.push(conversation.message);
    var isFrontendOnly = (_conversation$toolCal = conversation.toolCalls) === null || _conversation$toolCal === void 0 ? void 0 : _conversation$toolCal.some(function (tc) {
      var _tc$name;
      return FRONTEND_TOOL_NAMES.includes((_tc$name = tc.name) !== null && _tc$name !== void 0 ? _tc$name : "");
    });
    var hasBackendCall = (_conversation$toolCal2 = conversation.toolCalls) === null || _conversation$toolCal2 === void 0 ? void 0 : _conversation$toolCal2.some(function (tc) {
      var _tc$name2;
      return tc.type === "ActionExecutionMessage" && !FRONTEND_TOOL_NAMES.includes((_tc$name2 = tc.name) !== null && _tc$name2 !== void 0 ? _tc$name2 : "");
    });
    var backendCall = (_conversation$toolCal3 = conversation.toolCalls) === null || _conversation$toolCal3 === void 0 ? void 0 : _conversation$toolCal3.find(function (tc) {
      var _tc$name3;
      return tc.type === "ActionExecutionMessage" && !FRONTEND_TOOL_NAMES.includes((_tc$name3 = tc.name) !== null && _tc$name3 !== void 0 ? _tc$name3 : "");
    });
    if (!isFrontendOnly && hasBackendCall && backendCall) {
      result.push({
        id: backendCall.id,
        createdAt: backendCall.createdAt,
        type: "ActionExecutionMessage",
        name: "fallback_handler",
        arguments: {
          query: conversation.message.content
        }
      }, {
        id: "result-".concat(backendCall.id),
        createdAt: backendCall.createdAt,
        type: "ResultMessage",
        actionExecutionId: backendCall.id,
        actionName: "fallback_handler",
        result: JSON.stringify({
          type: "success"
        })
      });
    } else {
      var _conversation$toolCal4;
      result.push.apply(result, _toConsumableArray((_conversation$toolCal4 = conversation.toolCalls) !== null && _conversation$toolCal4 !== void 0 ? _conversation$toolCal4 : []));
    }
  });
  return result;
}